/**
 * Checks whether the specified date is expired
 * 
 * @param dateTime - the expiration date and time 
 * @returns true if the specified date is expired, otherwise false
 */
export const isExpired = (dateTime: Date): boolean => {
    const now = new Date();

    return dateTime < now;
}